module.exports = __webpack_public_path__ + "assets/house.41bc4055.svg";